module.exports = __webpack_public_path__ + "images/emoji/cocktail.f35961af9c0b56d86442.png";